import React from 'react';
import { Switch, Route } from 'react-router';
import { YMInitializer } from 'react-yandex-metrika';
import { SnackbarProvider } from 'notistack';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';

import Catalog from './Containers/Catalog/Catalog';
import Good from './Containers/Good/Good';
import 'react-fancybox/lib/fancybox.css';
import './styles/Catalog.css';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#669900',
      contrastText: '#fff'
    }
  },
  typography: {
    fontFamily: 'Roboto, "Open Sans", sans-serif',
    h6: {
      fontSize: '1rem',
      fontWeight: 600
    }
  }
});

export default (
  <ThemeProvider theme={theme}>
    <YMInitializer accounts={[43980294]} options={{ webvisor: true }} />
    <SnackbarProvider
      maxSnack={3}
      hideIconVariant
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right'
      }}
    >
      <Switch>
        <Route path="/good/:id" component={Good} />
        <Route path="/" component={Catalog} exact />
      </Switch>
    </SnackbarProvider>
  </ThemeProvider>
);
